<template>
  <v-container fluid class="paystatement-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header>
              <v-stepper-step :complete="step > 1" step="1"
                >Pay Statement</v-stepper-step
              >
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2"
                >Items</v-stepper-step
              >
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Pay Statement</p>
                        <v-menu
                          ref="menu_paystatementdate"
                          v-model="menu_paystatementdate"
                          :close-on-content-click="false"
                          :return-value.sync="paystatement.paystatementdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="paystatement.paystatementdate"
                              label="Pay Statement Date"
                              v-bind="attrs"
                              v-bind:value="paystatement.paystatementdate"
                              v-bind:error="errorindex == 0"
                              v-on="on"
                              single-line
                              hint="Enter pay statement date"
                            >
                              ></v-text-field
                            >
                          </template>
                          <v-date-picker
                            v-model="paystatement.paystatementdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_paystatementdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="
                                $refs.menu_paystatementdate.save(
                                  paystatement.paystatementdate
                                )
                              "
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          ref="menu_paystatementstartdate"
                          v-model="menu_paystatementstartdate"
                          :close-on-content-click="false"
                          :return-value.sync="
                            paystatement.paystatementstartdate
                          "
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="paystatement.paystatementstartdate"
                              label="Period Start Date"
                              v-bind="attrs"
                              v-bind:value="paystatement.paystatementstartdate"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              single-line
                              hint="Enter period start date"
                            >
                              ></v-text-field
                            >
                          </template>
                          <v-date-picker
                            v-model="paystatement.paystatementstartdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_paystatementstartdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="
                                $refs.menu_paystatementstartdate.save(
                                  paystatement.paystatementstartdate
                                )
                              "
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          ref="menu_paystatementenddate"
                          v-model="menu_paystatementenddate"
                          :close-on-content-click="false"
                          :return-value.sync="paystatement.paystatementenddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="paystatement.paystatementenddate"
                              label="Period End Date"
                              v-bind="attrs"
                              v-bind:value="paystatement.paystatementenddate"
                              v-bind:error="errorindex == 2"
                              v-on="on"
                              single-line
                              hint="Enter period end date"
                            >
                              ></v-text-field
                            >
                          </template>
                          <v-date-picker
                            v-model="paystatement.paystatementenddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_paystatementenddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="
                                $refs.menu_paystatementenddate.save(
                                  paystatement.paystatementenddate
                                )
                              "
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="
                            employees.map((x) => {
                              return { text: x.employeename, value: x._id };
                            })
                          "
                          v-model="paystatement.employeeid"
                          v-bind:error="errorindex == 3"
                          v-on:change="populateEmployeeFields"
                          outlined
                          dense
                          placeholder="Employee"
                          persistent-hint
                          single-line
                          hint="Please choose the employee"
                        >
                        </v-select>
                        <v-text-field
                          class="mb-4"
                          v-model="paystatement.paystatementname"
                          v-bind:error="errorindex == 10"
                          outlined
                          dense
                          placeholder="Employee Name"
                          persistent-hint
                          single-line
                          hint="Enter the Employee Name"
                        >
                        </v-text-field>
                        <v-textarea
                          v-model="paystatement.paystatementaddress"
                          outlined
                          rows="2"
                          label="Address"
                          hint="please enter the employee address"
                        ></v-textarea>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-text-field
                          class="mb-4"
                          v-model="paystatement.paystatementphone"
                          v-bind:error="errorindex == 11"
                          outlined
                          dense
                          placeholder="Phone"
                          persistent-hint
                          single-line
                          hint="Enter the phone"
                        >
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="paystatement.paystatementmobile"
                          v-bind:error="errorindex == 12"
                          outlined
                          dense
                          placeholder="Mobile"
                          persistent-hint
                          single-line
                          hint="Enter the mobile phone"
                        >
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="paystatement.paystatementemail"
                          v-bind:error="errorindex == 12"
                          outlined
                          dense
                          placeholder="Email"
                          persistent-hint
                          single-line
                          hint="Enter the email"
                        >
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-text-field
                          class="mb-4"
                          v-model="paystatement.paymethod"
                          outlined
                          dense
                          placeholder="Payment Method"
                          persistent-hint
                          single-line
                          hint="Enter the pay method"
                        >
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="paystatement.paystatementnote"
                          v-bind:error="errorindex == 10"
                          outlined
                          dense
                          placeholder="Note"
                          persistent-hint
                          single-line
                          hint="Enter the note"
                        >
                        </v-text-field>
                        <v-switch
                          v-model="paystatement.paystatementstatus"
                          color="primary"
                          v-bind:label="paystatement.paystatementstatus"
                          value="Active"
                        ></v-switch>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                          to="/paystatement/list"
                          replace
                          outlined
                          color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          class="button-shadow"
                          color="primary"
                          @click="checkError"
                        >
                          Next
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <p class="text-h5">Items</p>
                      <v-form>
                        <v-row justify="center">
                          <v-col md="3">
                            <v-select
                              class="mb-4"
                              :items="
                                accounts
                                  .filter((x) => (x.accountclass = 'Payroll'))
                                  .map((x) => {
                                    return {
                                      text: x.accountname,
                                      value: x._id,
                                    };
                                  })
                              "
                              v-model="accountid"
                              v-bind:error="errorindex == 2"
                              outlined
                              dense
                              placeholder="Account"
                              persistent-hint
                              single-line
                              hint="Account"
                            >
                            </v-select>
                          </v-col>
                          <v-col md="3">
                            <v-text-field
                              v-model="transnote"
                              class="mb-4"
                              outlined
                              dense
                              placeholder="Note"
                              persistent-hint
                              single-line
                              hint="Note"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col md="2">
                            <v-text-field
                              v-model="transcredit"
                              class="mb-4"
                              outlined
                              dense
                              placeholder="Credit"
                              persistent-hint
                              type="number"
                              v-on:input="checkIncreaseAmount"
                              oninput="if(this.value < 0) this.value = 0;"
                              single-line
                              hint="Credit"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col md="2">
                            <v-text-field
                              v-model="transdebit"
                              class="mb-4"
                              outlined
                              dense
                              placeholder="Debit"
                              persistent-hint
                              type="number"
                              v-on:input="checkDecreaseAmount"
                              oninput="if(this.value < 0) this.value = 0;"
                              single-line
                              hint="Debit"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col md="1">
                            <v-btn
                              class="button-shadow"
                              color="success"
                              @click="addTransaction()"
                            >
                              Add
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-data-table
                          v-if="transactions.filter(x=>x.transsubtype=='Addition' || x.transsubtype=='Deduction').length>0"
                          :headers="headers"
                          hide-default-footer
                          :items="transactions.filter(x=>x.transsubtype=='Addition' || x.transsubtype=='Deduction')"
                          class="elevation-0"
                        >
                          <template v-slot:item.actions="{ item }">
                            <v-btn
                              icon
                              color="primary"
                              @click="loadTransaction(item)"
                            >
                              <v-icon>mdi-pencil-outline</v-icon>
                            </v-btn>
                            <v-btn
                              icon
                              color="primary"
                              @click="deleteTransaction(item)"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </template>
                          <template slot="body.append">
                            <tr>
                              <th></th>
                              <th>Net Pay</th>
                              <th>{{ calculateNetPay() }}</th>
                              <th></th>
                              <th></th>
                            </tr>
                          </template>
                        </v-data-table>
                        <v-data-table
                          v-if="transactions.filter(x=>x.transsubtype=='Contribution').length>0"
                          :headers="headers"
                          hide-default-footer
                          :items="transactions.filter(x=>x.transsubtype=='Contribution')"
                          :items-per-page="100"
                          class="elevation-0"
                        >
                          <template v-slot:item.actions="{ item }">
                            <v-btn
                              icon
                              color="primary"
                              @click="loadTransaction(item)"
                            >
                              <v-icon>mdi-pencil-outline</v-icon>
                            </v-btn>
                            <v-btn
                              icon
                              color="primary"
                              @click="deleteTransaction(item)"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </template>
                          <template slot="body.append">
                            <tr>
                              <th></th>
                              <th>Total Contribution</th>
                              <th>{{ calculateContribution() }}</th>
                              <th></th>
                              <th></th>
                            </tr>
                          </template>
                        </v-data-table>
                        <v-data-table
                          v-if="transactions.filter(x=>x.transsubtype=='Benefit').length>0"
                          :headers="headers"
                          hide-default-footer
                          :items="transactions.filter(x=>x.transsubtype=='Benefit')"
                          :items-per-page="100"
                          class="elevation-0"
                        >
                          <template v-slot:item.actions="{ item }">
                            <v-btn
                              icon
                              color="primary"
                              @click="loadTransaction(item)"
                            >
                              <v-icon>mdi-pencil-outline</v-icon>
                            </v-btn>
                            <v-btn
                              icon
                              color="primary"
                              @click="deleteTransaction(item)"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                        <v-data-table
                          v-if="transactions.filter(x=>x.transsubtype=='Saving').length>0"
                          :headers="headers"
                          hide-default-footer
                          :items="transactions.filter(x=>x.transsubtype=='Saving')"
                          :items-per-page="100"
                          class="elevation-0"
                        >
                          <template v-slot:item.actions="{ item }">
                            <v-btn
                              icon
                              color="primary"
                              @click="loadTransaction(item)"
                            >
                              <v-icon>mdi-pencil-outline</v-icon>
                            </v-btn>
                            <v-btn
                              icon
                              color="primary"
                              @click="deleteTransaction(item)"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn outlined color="primary" @click="step = 1">
                          Back
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          :loading="isReceiving"
                          class="button-shadow"
                          color="primary"
                          @click="createPayStatement()"
                        >
                          Save
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-bottom-sheet v-model="sheet" inset>
        <v-sheet class="text-center" height="220px">
          <v-btn class="mt-6" text color="error" @click="sheet = !sheet">
            close
          </v-btn>
          <div class="my-3">
            <v-row justify="center">
                          <v-col md="3">
                            <v-select
                              class="mb-4"
                              :items="
                                accounts
                                  .filter((x) => (x.accountclass = 'Payroll'))
                                  .map((x) => {
                                    return {
                                      text: x.accountname,
                                      value: x._id,
                                    };
                                  })
                              "
                              v-model="accountid"
                              v-bind:error="errorindex == 2"
                              outlined
                              dense
                              placeholder="Account"
                              persistent-hint
                              single-line
                              hint="Account"
                            >
                            </v-select>
                          </v-col>
                          <v-col md="3">
                            <v-text-field
                              v-model="transnote"
                              class="mb-4"
                              outlined
                              dense
                              placeholder="Note"
                              persistent-hint
                              single-line
                              hint="Note"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col md="2">
                            <v-text-field
                              v-model="transcredit"
                              class="mb-4"
                              outlined
                              dense
                              placeholder="Credit"
                              persistent-hint
                              type="number"
                              v-on:input="checkIncreaseAmount"
                              oninput="if(this.value < 0) this.value = 0;"
                              single-line
                              hint="Credit"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col md="2">
                            <v-text-field
                              v-model="transdebit"
                              class="mb-4"
                              outlined
                              dense
                              placeholder="Debit"
                              persistent-hint
                              type="number"
                              v-on:input="checkDecreaseAmount"
                              oninput="if(this.value < 0) this.value = 0;"
                              single-line
                              hint="Debit"
                            >
                            </v-text-field>
                          </v-col>

              <v-col md="1"> </v-col>
            </v-row>
          </div>
          <v-btn
            class="button-shadow"
            color="warning"
            @click="editTransaction()"
          >
            Edit
          </v-btn>
        </v-sheet>
      </v-bottom-sheet>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import router from "@/Routes";

export default {
  data() {
    return {
      headers: [
        { text: "Account", value: "transdesc", width: '30%' },
        { text: "Note", value: "transnote", width: '20%'},
        { text: "Credit", value: "transcredit", width: '20%'},
        { text: "Debit", value: "transdebit", width: '20%'},
        { text: "Actions", value: "actions", sortable: false },
      ],
      transactions: [],
      sheet: false,
      cid: undefined,
      accountid: undefined,
      transnote: undefined,
      transcredit: undefined,
      transdebit: undefined,
      trandesc: undefined,
      transtype: undefined,
      step: 1,
      paystatement: {
        paystatementstatus: "Active",
      },
      menu_paystatementdate: false,
      menu_paystatementstartdate: false,
      menu_paystatementenddate: false,
      paystatementtypes: ["Pay Statement"],
      paystatementpayterms: ["Cash", "Credit 15 Days", "Credit 30 Days"],
      accountitems: [],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    };
  },

  methods: {
    ...mapActions("Account", ["getAccountsRequest"]),
    ...mapActions("Employee", ["getEmployeesRequest"]),
    ...mapActions("PayStatement", ["getPayStatements", "insertPayStatementRequest"]),
    addTransaction() {
      if (this.transcredit == null || this.transcredit == null) {
        return;
      }
      let index = this.findTransactionIndexByAccountid(this.accountid);
      if (index == -1) {
        this.insertTransaction();
      } else {
        this.updateTransaction(index);
      }
    },
    checkError() {
      if (!this.paystatement.paystatementdate) {
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if (!this.paystatement.paystatementstartdate) {
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if (!this.paystatement.paystatementenddate) {
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if (!this.paystatement.employeeid) {
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      if (!this.paystatement.paystatementname) {
        this.haserrors = true;
        this.errorindex = 4;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    checkIncreaseAmount(){
      if(this.transcredit>0){this.transdebit=0}
    },
    checkDecreaseAmount(){
      if(this.transdebit>0){this.transcredit=0}
    },
    calculateNetPay() {
      let trans = this.transactions.filter(x=>x.transsubtype=='Addition' || x.transsubtype=='Deduction');
      var list =  trans.map( trans => trans.transcredit-trans.transdebit  );
      return list.reduce((a,b)=>a+b);
    },
    calculateContribution() {
      let trans = this.transactions.filter(x=>x.transsubtype=='Contribution');
      var list =  trans.map( trans => trans.transcredit-trans.transdebit  );
      return list.reduce((a,b)=>a+b);
    },
    clearTransaction() {
      this.cid = undefined;
      this.itemid = undefined;
      this.itemimage = undefined;
      this.itemname = undefined;
      this.itemquantity = 1;
      this.itemprice = undefined;
      this.itemamount = undefined;
      this.itemcategoryid = undefined;
      this.itemsubcategoryid = undefined;
    },
    deleteTransaction(item) {
      let index = this.findTransactionIndexById(item.id);
      this.transactions.splice(index, 1);
    },

    insertTransaction() {
      let account = this.accounts.find((account) => account._id == this.accountid);
      this.transactions.push({
        id: Math.floor(Math.random() * Math.pow(10, 10)),
        employeeid: this.paystatement.employeeid,
        accountid: this.accountid,
        transtype: account.accountsubclass,
        transsubtype: account.accountsubtype,
        transdesc: account.accountname,
        transnote: this.transnote,
        transcredit: this.transcredit,
        transdebit: this.transdebit,
      });
    },
    populateEmployeeFields(employeeid) {
      let employee = this.employees.find((employee) => employee._id == employeeid);
      this.paystatement.paystatementname = employee.employeename;
      this.paystatement.paystatementaddress = employee.employeeaddress;
      this.paystatement.paystatementphone = employee.employeephone;
      this.paystatement.paystatementmobile = employee.employeemobile;
      this.paystatement.paystatementemail = employee.employeeemail;
      this.paystatement.paymethod = employee.paymethod;
    },
    updateTransaction(index) {
      var tran = this.transactions[index];
      tran.transcredit = parseFloat(tran.transcredit) + parseFloat(this.transcredit);
      tran.transdebit = parseFloat(tran.transdebit) + parseFloat(this.transdebit);
    },
    loadTransaction(item) {
      this.sheet = !this.sheet;
      this.cid = item.id;
      this.accountid = item.accountid;
      this.transnote = item.transnote;
      this.transcredit = item.transcredit;
      this.transdebit = item.transdebit;
    },
    editTransaction() {
      let trans = this.transactions.find((tran) => tran.id == this.cid);
      let account = this.accounts.find((account) => account._id == this.accountid);

      trans.accountid = this.accountid;
      trans.transtype = account.accountsubclass,
      trans.transsubtype = account.accountsubtype,
      trans.transdesc = account.accountname,
      trans.transnote = this.transnote;
      trans.transcredit = this.transcredit;
      trans.transdebit = this.transdebit;
      this.sheet = !this.sheet;
    },
    findTransactionIndexById(id) {
      let index;
      if (this.transactions.find((tran) => tran.id == id) == null) {
        return -1;
      }
      for (index = 0; index < this.transactions.length; index++) {
        if (this.transactions[index].id == id) {
          break;
        }
      }
      return index;
    },
    findTransactionIndexByAccountid(accountid) {
      let index;
      if (
        this.transactions.find((tran) => tran.accountid == accountid) == null
      ) {
        return -1;
      }
      for (index = 0; index < this.transactions.length; index++) {
        if (this.transactions[index].accountid == accountid) {
          break;
        }
      }
      return index;
    },
    async createPayStatement() {
      let payload = {
        paystatement: this.paystatement,
        transactions: this.transactions,
      };
      
      await this.insertPayStatementRequest(payload);
      router.push("/paystatement/list");
    },
  },
  computed: {
    ...mapState("Account", ["accounts"]),
    ...mapState("Employee", ["employees"]),
    ...mapState("PayStatement", ["isReceiving"]),
  },
  created() {
    if (this.accounts.length == 0) {
      this.getAccountsRequest();
    }
    if (this.employees.length == 0) {
      this.getEmployeesRequest();
    }
  },
};
</script>

<style src="./Add.scss" lang="scss"></style>
